import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../core/services/language.service';

interface LanguageOption {
  code: string;
  name: string;
  flag: string;
}

@Component({
  selector: 'app-language-switcher',
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
  standalone: false,
})
export class LanguageSwitcherComponent implements OnInit {
  isOpen = false;
  currentLanguage: LanguageOption;

  readonly languages: LanguageOption[] = [
    { code: 'de', name: 'Deutsch', flag: 'assets/images/flags/germany.svg' },
    { code: 'fr', name: 'Français', flag: 'assets/images/flags/france.svg' },
    { code: 'it', name: 'Italiano', flag: 'assets/images/flags/italy.svg' },
    { code: 'en', name: 'English', flag: 'assets/images/flags/united-kingdom.svg' },
  ];

  constructor(
    private languageService: LanguageService,
    private translate: TranslateService
  ) {
    const currentCode = this.languageService.getCurrentLanguage();
    this.currentLanguage = this.languages.find(l => l.code === currentCode) || this.languages[0];
  }

  ngOnInit(): void {
    const currentCode = this.languageService.getCurrentLanguage();
    this.currentLanguage = this.languages.find(l => l.code === currentCode) || this.languages[0];
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  closeDropdown(): void {
    this.isOpen = false;
  }

  selectLanguage(language: LanguageOption): void {
    this.currentLanguage = language;
    this.languageService.setLanguage(language.code);
    this.isOpen = false;
  }
}
